<script setup lang="ts">
import type { PropType } from 'vue'

defineProps({
  title: {
    type: String,
    default: '',
  },
  more: {
    type: Boolean,
    default: false,
  },
  showMore: {
    type: Function as PropType<(payload: any) => any>,
    default: () => ({}),
  },
  border: {
    type: Boolean,
    default: false,
  },
  side: {
    type: Boolean,
    default: false,
  },
  fontSize: {
    type: Number,
    default: 22,
  },
  moreFontSize: {
    type: Number,
    default: 16,
  },
  contentMT: {
    type: Number,
    default: 13,
  },
})

const hasExtraSlot = computed(() => {
  return !!useSlots().extra
})
</script>

<template>
  <div :class="`ref-card ${side ? 'side' : ''}`">
    <div v-if="title || more || hasExtraSlot" class="info">
      <div v-show="title" class="title" :style="`font-size: ${fontSize}px`">
        {{ title }}
      </div>
      <div v-show="more" :style="`font-size: ${moreFontSize}px`" class="more" @click="showMore">
        查看更多
      </div>
      <div class="extra">
        <slot name="extra" />
      </div>
    </div>
    <div :style="`margin-top: ${contentMT}px`" :class="`content ${border ? 'border' : ''}`">
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
.ref-card {
  width: 100%;

  .info {
    height: 40px;
    line-height: 40px;
    position: relative;

    .title {
      //font-size: 22px;
      font-weight: bold;
      float: left;
    }

    .extra {
      float: right;
    }

    .more {
      float: right;
      font-size: 16px;
      font-weight: normal;
      color: #8B8A8A;
      cursor: pointer;
    }
  }
  .content {
    width: 100%;
    //margin-top: 13px;
    padding: 13px 0;
    border-radius: 4px;
  }
  .border {
    border: 1px solid #E6E6E6;
  }
}
.side {
  border: 1px solid #E6E6E6;
  padding: 8px 13px;

  .content {
    margin-top: unset;
  }
}
</style>
